import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualsService, ResetIndividualPasswordRequest } from '@aslanpay/portal-common-lib';

const useResetIndividualPassword = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, ResetIndividualPasswordRequest>) => {
  return useMutation<unknown, Error, ResetIndividualPasswordRequest>(
    ({ email }: ResetIndividualPasswordRequest) =>
      individualsService.resetIndividualPassword({ email: email.toLowerCase() }),
    { onSuccess, onError }
  );
};

export default useResetIndividualPassword;
